<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="职业名称">
								<a-input v-model="queryParams.workName" placeholder="名称" />
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/system/professionAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false" :defaultExpandAllRows="false" childrenColumnName="children">
				
				<template slot="action" slot-scope="record">
					<a v-has="'/system/professionUpdate'" @click="update(record)">修改</a>
					<a-divider type="vertical" />
					<a-popconfirm placement="topRight" title="你确定要删除本条记录?" @confirm="professionDel(record.id)">
						<a v-has="'/system/professionDel'" href="#">删除</a>
					</a-popconfirm>
				</template>
			</a-table>

			<Profession-form-modal ref="ProfessionForm" :visible="ProfessionFormVisible" :loading="ProfessionFormLoading" :model="ProfessionFormModel"
				@cancel="ProfessionFormCancel" @ok="ProfessionFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import ProfessionFormModal from "@/pages/system/profession/ProfessionForm.vue";
	import {
		professionList,
		professionAdd,
		professionUpdate,
		professionDel
	} from "@/api/system/profession";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '职业名称',
			dataIndex: 'workName'
		},
		{
			title: '职业人数量',
			dataIndex: 'selectedNum'
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			ProfessionFormModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				ProfessionFormVisible: false,
				ProfessionFormLoading: false,
				ProfessionFormModel: null,
				createTime: [],
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				professionList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.ProfessionFormModel = null;
				this.ProfessionFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.ProfessionForm && this.$refs.ProfessionForm.initForm) {
						this.$refs.ProfessionForm.initForm();
					}
				});
			},
			update(record) {
				this.ProfessionFormModel = {
					...record
				};
				this.ProfessionFormVisible = true;
			},
			ProfessionFormOk() {
				const professionForm = this.$refs.ProfessionForm;
				if (!professionForm || !professionForm.$refs.adminForm) {
					return;
				}
				professionForm.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...professionForm.form };
					this.ProfessionFormLoading = true;
					if (values.id > 0) {
						professionUpdate(values).then(() => {
							this.ProfessionFormAfter('修改用户成功');
						}).catch(() => {
							this.ProfessionFormLoading = false;
						});
					} else {
						professionAdd(values).then(() => {
							this.ProfessionFormAfter('新增用户成功');
						}).catch(() => {
							this.ProfessionFormLoading = false;
						});
					}
				});
			},
			ProfessionFormCancel() {
				this.ProfessionFormModel = null;
				this.ProfessionFormVisible = false;
				if (this.$refs.ProfessionForm && this.$refs.ProfessionForm.initForm) {
					this.$refs.ProfessionForm.initForm();
				}
			},
			ProfessionFormAfter(message) {
				this.ProfessionFormVisible = false;
				this.ProfessionFormLoading = false;
				if (this.$refs.ProfessionForm && this.$refs.ProfessionForm.initForm) {
					this.$refs.ProfessionForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.createTime = [];
				this.queryParams = {}
			},
			professionDel(id) {
				professionDel(id).then(() => {
					this.fetchTableData();
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	
</style>